<template>
    <span>
        <permission-container :permissionId="permissionId">
            <span class="wrap-text">{{ clientName||'' }}</span>
        </permission-container>
        <span>{{ clientCode||'' }}</span>
    </span>
</template>

<script>
    export default {
        name: "ClientInfoRender",
        props: {
            permissionId: String,
            clientName: [String],
            clientCode: [String, Number],
        },
        data()
        {
            return {

            }
        },
        methods:
        {

        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/erp/components/render/ClientInfoRender.vue